import React from 'react';
import PropTypes from 'prop-types';
import { DragSource, DropTarget } from 'react-dnd';
import { Icon, Input } from 'antd';
import classNames from 'classnames/bind';
import ItemTypes from '../ItemTypes';
import styles from '../../emailTemplates.less';

const cx = classNames.bind(styles);

const defaultProps = {};
const propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  moveCard: PropTypes.func.isRequired,
};

const cardSource = {
  beginDrag({ id, index }) {
    return { id, index };
  },
};

const cardTarget = {
  drop(props, monitor) {
    const { index, moveCard } = props;
    const dragIndex = monitor.getItem().index;
    const hoverIndex = index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) return;

    // Time to actually perform the action
    moveCard(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

class DraggableFolder extends React.Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      item,
      onDeleteFolder,
      onUpdateFolderName,
    } = this.props;

    return connectDragSource(
      connectDropTarget(
        <div>
          <div>
            <Icon
              className={cx(['folder-icon', 'folder-move'])}
              type="folder"
            />
            <Icon
              className={classNames(cx('delete-icon'), 'pl-sm')}
              type="delete"
              onClick={() => onDeleteFolder(item.id)}
            />
          </div>
          {isOver &&
            <div style={{
              position: 'absolute',
              top: 0,
              left: 5,
              height: '90%',
              width: '3px',
              zIndex: 1,
              opacity: 1,
              backgroundColor: '#FB8C00',
            }}
            />
          }
          <Input
            onChange={e => onUpdateFolderName(item.id, e.target.value)}
            size="small"
            defaultValue={item.name}
          />
        </div>
      )
    );
  }
}

DraggableFolder.defaultProps = defaultProps;
DraggableFolder.propTypes = propTypes;
export default _.flow(
  DragSource(ItemTypes.FOLDER, cardSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })),
  DropTarget(ItemTypes.FOLDER, cardTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  }))
)(DraggableFolder);



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/Folders/DraggableFolder.jsx